export enum InvestEntity {
    INVESTOR = 1,
    INVESTEE = 2,
}

export enum InvestEntityType {
    INVESTOR = 'investor',
    INVESTEE = 'investee',
}
